/*
 * Filename: \src\Settings\Vendors\AddVendor\AddVendorContext.js
 * Created Date: 2025-12-10 12:26
 * Author: jdkohl
 * 
 * Copyright (c) 2025 Logical Developments
 */


import { createContext, useContext, useReducer } from "react";
import { Vendor } from '../Vendors';

export const AddVendorContext = createContext(null);

export function useAddVendorContext() {
  const context = useContext(AddVendorContext);
  if (context === undefined) {
    throw new Error("useAddVendorContext must be used within an AddVendorContext provider.");
  } else {
    return context;
  }
}


export function AddVendorProvider({ children })  {
  const initialValue = new Vendor({});
  const [vendor, updateVendor] = useReducer(vendorReducer, initialValue)

  return (
    <AddVendorContext.Provider value={{ vendor, updateVendor }}>
      {children}
    </AddVendorContext.Provider>
  )
}

/**
 * Reducer function for updating the vendor
 * @param {Object} vendor The current state of the vendor object
 * @param {Object} action The action the reducer should take
 * @param {string} action.type The type of action the reducer should take.
 * @param {string} action.[key] For a "key" action, the key to update with the provided value. 
 * @param {string} action.[value] For the "key" and "update" actions, the value to apply.
 * @returns {Object}
 */
function vendorReducer(vendor, { type, key, value}) {
  switch (type) {
    case 'key':
      if (Object.keys(vendor).includes(key))
        return { ...vendor, [key]: value };
      else
        throw new Error(`Invalid key for update: ${key}`);

    case 'update':
      // Merge API response into vendor (for id and code)
      return { ...vendor, ...value };

    case 'reset':
      // Reset to fresh vendor
      return new Vendor({});

    default:
      throw new Error(`Unknown action type: ${type}`);
  }
}